<body class="body popup-loader counter-scroll">
  <!-- wrapper -->
  <div id="wrapper">
    <!-- page-title-home-2 -->
    <div class="tf-section">
      <div class="page-title-home style-2">
        <div class="tf-container">
          <div class="col-12">
            <div class="page-title-home-content content">
              <!-- Immagine principale -->
              <img src="../assets/images/item/game-slot-3-1-LARGE.png"
                data-src="../assets/images/item/game-slot-3-1-LARGE.png" alt="Game Slot Image" class="lazyload" />
              <!-- Jackpot Section -->
              <div class="jackpot-amount">
                <p class="text-color-clip">
                  Our jackpot is <br /><br />
                  <span class="cd-words-wrapper">
                    <span class="item-text text-color-clip fs-70">€ {{ jackpotAmount }}</span>
                  </span>
                </p>
                <div *ngIf="isLogged else notLogged">
                  <div *ngIf="allowUserPurchase else justPlayed">
                    <div class="tf-btn">
                      <a routerLink="purchase">
                        <i class="icon-tickets"></i>&nbsp;&nbsp;Buy a Ticket
                      </a>
                    </div>
                  </div>

                </div>
                <ng-template #notLogged>
                  <div class="tf-btn">
                    <a (click)="openLoginModal()" tabindex="0" (keydown.enter)="openLoginModal()">
                      <i class="icon-tickets"></i>&nbsp;&nbsp;Buy a Ticket
                    </a>
                  </div>
                </ng-template>

                <ng-template #justPlayed>
                  <div class="tf-btn style-1">
                    <a (click)="noticeJustPlayed()" tabindex="0" (keydown.enter)="noticeJustPlayed()">
                      <i class="icon-tickets"></i>&nbsp;&nbsp;Buy a Ticket
                    </a>
                  </div>
                </ng-template>

                <a *ngIf="!isTryMode" href="{{tryModeUrl}}" class="text-color-clip want-to-try">Want to try the game?<br />Click here!</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /page-title-home-2 -->

    <!-- main-content -->
    <div class="main-content page-contest-details">
      <div class="row">
        <div class="col-12">
          <!-- Countdown -->
          <app-countdown *ngIf="playPeriod" [playPeriod]="playPeriod"></app-countdown>
          <br /><br /><br />
          <!-- Risultati Lotteria -->
          <div class="custom-container">
            <app-lottery-results [title]="'Most voted ticket'" [results]="tickets" [columns]="[
                { header: 'Tickets', field: 'numbers' },
                { header: 'Votes', field: 'votes' }
              ]" [pagination]="pagination" (pageChange)="onPageChange($event)">
            </app-lottery-results>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
